export enum TaxType {
  VAT,
  SalesTax,
}
